const regex = /lang=['"]{1}[a-zA-Z]+['"]{1} *>/g;

export const getSpanInformations = (
  partOfText: string
): { spanContent: string; language?: string } => {
  const foundLangsFull = partOfText.match(regex);
  if (!foundLangsFull) {
    return { spanContent: partOfText };
  }
  const foundLang = foundLangsFull[0]
    .replace('lang=', '')
    .replaceAll("'", '')
    .replaceAll('"', '')
    .replace('>', '')
    .trim();
  return {
    spanContent: partOfText.replace(foundLangsFull[0], ''),
    language: foundLang,
  };
};

export const clearSpan = (partOfText: string): string => {
  const textWithoutSpans = partOfText
    .replaceAll('<span ', '')
    .replaceAll('</span>', '');
  return textWithoutSpans.replaceAll(regex, '');
};

export const getSortInfo = (a: string, b: string, language: string): number => {
  return new Intl.Collator(language.toLowerCase()).compare(
    clearSpan(a),
    clearSpan(b)
  );
};
